import http from './http';

/**
 * @param {string} tenantId
 * @param {Object} payload
 * @param {string} payload.senderName
 * @param {string} payload.senderEmail
 * @param {string} payload.docSignatureClientId
 * @param {Object} payload.documents
 */
export async function createTenantSettings(tenantId, payload = {}) {
  if (!tenantId) {
    throw new Error('tenantId is required.');
  }

  try {
    const wrappedData = {
      data: {
        ...payload,
        companyId: tenantId,
      },
    };
    const { data } = await http.post(
      `/onboarding/settings/tenants/${tenantId}`,
      wrappedData
    );
    return data?.data || {};
  } catch (e) {
    // ignore not found
    if (e?.response?.status === 404) {
      return {};
    }

    throw new Error(e?.response?.error?.message || e);
  }
}
